"use client";

import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import { ProductCard } from "@/components/ProductCard/ProductCard.component";
import { Translation } from "@/components/Translation/Translation.component";
import { usePaywall } from "@/contexts/paywall/paywall.context";
type FallbackProductProps = {
  readonly className?: string;
  readonly size?: "small" | "medium" | "large" | "default";
  readonly variant?: "primary" | "default" | "subtle";
  readonly position?: string;
};
export function FallbackProduct(t0) {
  const $ = _c(17);
  const {
    className,
    size,
    position
  } = t0;
  const {
    yearlyProduct,
    shopLinks: t1
  } = usePaywall();
  const {
    consumerUrl
  } = t1;
  let t2;
  if ($[0] !== className) {
    t2 = clsx(className, "relative flex hover:z-10 lg:py-2");
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      da: "Bliv kontaktet",
      de: "Kontaktieren Sie uns",
      en: "Get in touch",
      no: "Bli kontaktet",
      sv: "Bli kontaktad"
    };
    t4 = {
      da: "\xC9n bruger",
      de: "Ein Benutzer",
      en: "One user",
      no: "\xC9n bruker",
      sv: "En anv\xE4ndare"
    };
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      da: "Personligt abonnement",
      de: "Pers\xF6nliches Abonnement",
      en: "Personal subscription",
      no: "Personlig abonnement",
      sv: "Personligt abonnemang"
    };
    t6 = {
      contentId: "fallback",
      contentSource: "paywall",
      contentType: "cta"
    };
    $[4] = t5;
    $[5] = t6;
  } else {
    t5 = $[4];
    t6 = $[5];
  }
  const t7 = yearlyProduct === null ? "primary" : "default";
  let t8;
  if ($[6] !== consumerUrl || $[7] !== position || $[8] !== t7) {
    t8 = {
      buttonTranslations: t3,
      periodHeadingTranslations: t4,
      position,
      testId: "fallback-product-id",
      titleTranslations: t5,
      trackingModel: t6,
      url: consumerUrl,
      variant: t7
    };
    $[6] = consumerUrl;
    $[7] = position;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <p className="text-sm"><Translation da={"Fuld adgang for \xE9n person"} de={"Voller Zugang f\xFCr eine Person"} en="Full access for one person" no={"Full tilgang for \xE9n person"} sv={"Full tillg\xE5ng f\xF6r en person"} /></p>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== size || $[12] !== t8) {
    t10 = <ProductCard model={t8} size={size}>{t9}</ProductCard>;
    $[11] = size;
    $[12] = t8;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t2) {
    t11 = <div className={t2}>{t10}</div>;
    $[14] = t10;
    $[15] = t2;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
}